import { ComponentStyleConfig } from '@chakra-ui/react';

export const Modal: ComponentStyleConfig = {
  baseStyle: {
    overlay: {
      bg: 'transparent',
      _after: {
        content: '""',
        width: 'full',
        height: 'full',
        position: 'absolute',
        top: 0,
        left: 0,
        bg: 'rgba(0, 0, 0, 0.76)',
      },
    },
    dialogContainer: {
      '@supports(height: -webkit-fill-available)': {
        height: '-webkit-fill-available',
      },
      '@supports(height: 100lvh)': {},
      '@supports(height: 100svh)': {
        '--chakra-vh': '100svh',
      },
      p: { base: 4, lg: 8 },
      overflowY: 'auto',
    },
    dialog: {
      bg: 'M.10',
      margin: 'auto',
      borderRadius: 6,
      width: 'full',
    },
    header: {
      fontSize: 'md',
      fontWeight: 500,
      color: 'M.70',
      lineHeight: 1.4,
      p: 4,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    body: {
      px: 4,
      pt: 2,
      pb: 0,
    },
    footer: {
      p: 4,
    },
  },
  sizes: {
    default: {
      dialog: {
        maxW: '512px',
      },
    },
    sm: {
      dialog: {
        maxW: '312px',
      },
    },
    md: {
      dialog: {
        maxW: '600px',
      },
    },
    lg: {
      dialog: {
        maxW: '800px',
      },
    },
    xl: {
      dialog: {
        maxW: '1200px',
      },
    },
    full: {
      dialogContainer: {
        p: 0,
      },
    },
    mobile: {
      dialogContainer: {
        p: 4,
      },
    },
  },
  variants: {
    blurredBg: {
      overlay: {
        bg: 'rgba(255, 255, 255, 0.92)',
        _after: {
          bg: 'rgba(0, 0, 0, 0.5)',
        },
      },
    },
    imageBg: {
      dialog: {
        overflow: 'hidden',
        maxW: '1100px',
        '@media only screen and (max-width: 768px)': {
          maxW: '620px',
        },
      },
      body: {
        p: 0,
        overflowX: 'hidden',
      },
    },
    fitContent: {
      dialog: {
        w: 'fitContent',
        minWidth: '312px',
      },
    },
  },
  defaultProps: {
    size: 'default',
  },
};
